import React, { FC } from 'react';
import styled from 'styled-components';

import { PortalLogo } from 'componentsShared/Icons';

const SignUpIntroductionMobile: FC = () => (
  <SLogoWrapper>
    <PortalLogo />
  </SLogoWrapper>
);

export default SignUpIntroductionMobile;

const SLogoWrapper = styled.div`
  width: 100%;
  height: 73px;
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    height: 42px;
  }
`;
